"use strict";
// import { cardKeyboard } from '../input/cardKeyboard-sidecar'
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var _isCameraMoveDown = false;
var _mx = 0;
var _my = 0;
var _sx = 0;
var _sy = 0;
function update(obj) {
    // let ap = common.getPhaserScene().game.input.activePointer
    // if (ap.middleButtonDown() || ap.rightButtonDown()) {
    //   if (!_isCameraMoveDown) {
    //     _isCameraMoveDown = true
    //     _mx = ap.x
    //     _my = ap.y
    //     _sx = obj.cameraX
    //     _sy = obj.cameraY
    //   }
    //   rogueCamera.setCameraXY(_sx + -(ap.x - _mx), _sy + -(ap.y - _my))
    // } else {
    //   _isCameraMoveDown = false
    //   let dt = common.getUpdateDelta()
    //   let speed = 1000
    //   let dirX = 0
    //   let dirY = 0
    //   let keys = cardKeyboard.getKeys()
    //   if (keys.cameraLeft) {
    //     dirX -= speed
    //   }
    //   if (keys.cameraRight) {
    //     dirX += speed
    //   }
    //   if (keys.cameraUp) {
    //     dirY -= speed
    //   }
    //   if (keys.cameraDown) {
    //     dirY += speed
    //   }
    //   rogueCamera.setCameraXY(obj.cameraX + dirX * dt, obj.cameraY + dirY * dt)
    //  }
}
exports.update = update;
